module.exports = __webpack_public_path__ + "images/b2bc498cc8f48a40db55c3c0785fb6b843815d4608dc8fec97cdc2ef7c3c4fdc.svg";